import { fetcher } from "./fetcher";
import { createStep } from "./scenario-manager";
import {
  addFieldData,
  addSubStep,
  replaceSubStep,
  setActiveStep,
  stopLoading
} from "../actions";
import Simple from "../components/protocole/Simple";
import { translator } from "./i18n";
import FormProtocol from "../components/protocole/FormProtocol";
import { GROUP_PROTOCOL } from "./constants";

export const getProtocol = url => {
  return (dispatch, getState) => {
    fetcher()
      .get(`cache_ajax/${url}`)
      .then(response => response.json())
      .then(json => {
        const subStepIntro = createStep({
          label: translator()._("W_PROTOCOLE"),
          icon: "images/icone-motif.png",
          component: {
            type: Simple,
            label: ""
          },
          data: {
            fetchSource: () =>
              addFieldData("introProtocol", json.textdebut_protocole),
            keyValue: "introProtocol"
          },
          selfRemove: {
            group: GROUP_PROTOCOL
          }
        });
        dispatch(
          addSubStep(
            getState().activeStep.step,
            subStepIntro,
            getState().activeStep.subStep
          )
        );
        // go to added step
        dispatch(setActiveStep({ subStep: getState().activeStep.subStep + 1 }));

        const subStepForm = createStep({
          label: translator()._("W_PROTOCOLE"),
          icon: "images/icone-motif.png",
          response: json.liste_page_fils,
          component: {
            type: FormProtocol,
            label: ""
          },
          data: {
            fetchSource: () =>
              addFieldData("formProtocol", json.liste_formulaire_protocole),
            keyValue: "formProtocol"
          },
          selfRemove: {
            group: GROUP_PROTOCOL
          }
        });
        dispatch(
          addSubStep(
            getState().activeStep.step,
            subStepForm,
            getState().activeStep.subStep
          )
        );
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const responseProtocol = (value, response) => {
  return (dispatch, getState) => {
    const item =
      response.find(item => item.reponse === value) ||
      response.find(item => item.reponse === "default");
    if (item.filcall) {
      fetcher()
        .get(`cache_ajax/${item.filcall}`)
        .then(response => response.json())
        .then(json => {
          const subStep = createStep({
            label: translator()._("W_PROTOCOLE"),
            icon: "images/icone-motif.png",
            component: {
              type: Simple,
              label: ""
            },
            data: {
              fetchSource: () =>
                addFieldData("responseProtocol", json.textfinok_protocole),
              keyValue: "responseProtocol"
            },
            selfRemove: {
              group: GROUP_PROTOCOL
            }
          });
          dispatch(
            replaceSubStep(
              getState().activeStep.step,
              subStep,
              getState().activeStep.subStep
            )
          );
          // go to added step
          dispatch(
            setActiveStep({ subStep: getState().activeStep.subStep + 1 })
          );
          fetcher(true, item.reponse !== "default" ? { type: "ortho" } : {});
          dispatch(stopLoading());
        })
        .catch(() => {
          dispatch(stopLoading());
        });
    }
  };
};
